<template>
  <div :class="activatorWrapperClass">
    <v-dialog
      v-model="dialog"
      content-class="sc-modal sc-modal--sm"
      max-width="630"
      @keydown.esc="fechar"
    >
      <template v-if="hasActivator" v-slot:activator="{ on, attrs }">
        <slot name="activator" v-bind="{ on, attrs }" />
      </template>

      <v-card flat class="sc-modal__card">
        <v-btn icon class="sc-modal__close" @click="fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <div class="sc-modal__header">
          <div>
            <span class="sc-modal__title">{{ title }}</span>
          </div>
        </div>

        <div class="sc-modal__body">
          <strong class="confirm-message">{{ message }}</strong>
          <strong v-if="showWarning" class="confirm-warning">
            ATENÇÃO: {{ warningText }}
          </strong>
        </div>

        <div class="sc-modal__footer">
          <v-btn
            class="modal-btn-cancel"
            :disabled="loading"
            @click="fechar"
          >
            {{ cancelText }}
          </v-btn>
          <v-btn
            :class="['confirm-btn', !confirmColor || confirmColor === 'red' ? 'confirm-btn--danger' : 'confirm-btn--custom']"
            :style="confirmColor && confirmColor !== 'red' ? { backgroundColor: `var(--v-${confirmColor}-base)` } : {}"
            :loading="loading"
            :disabled="loading"
            @click="confirmar"
          >
            {{ confirmText }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ModalConfirmAction",
  props: {
    visible: { type: Boolean, default: null },
    title: { type: String, default: "Confirmar ação" },
    message: { type: String, default: "Deseja confirmar esta ação?" },
    warning: { type: String, default: null },
    confirmText: { type: String, default: "Excluir" },
    confirmColor: { type: String, default: null },
    cancelText: { type: String, default: "Cancelar" },
    loading: { type: Boolean, default: false },
    activatorWrapperClass: { type: String, default: "" },
  },
  data() {
    return {
      internalDialog: false,
    };
  },
  computed: {
    hasActivator() {
      return !!(this.$slots.activator || this.$scopedSlots.activator);
    },
    showWarning() {
      return this.warning !== null || !this.confirmColor || this.confirmColor === 'red';
    },
    warningText() {
      return this.warning || "Essa ação não poderá ser revertida.";
    },
    dialog: {
      get() {
        // Parent-controlled mode (visible prop) or self-controlled (activator slot)
        return this.visible !== null ? this.visible : this.internalDialog;
      },
      set(value) {
        if (this.visible !== null) {
          if (!value) this.$emit("cancel");
        } else {
          this.internalDialog = value;
        }
      },
    },
  },
  methods: {
    confirmar() {
      this.$emit("confirm");
    },
    fechar() {
      if (this.visible !== null) {
        this.$emit("cancel");
      } else {
        this.internalDialog = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-message,
.confirm-warning {
  font-size: var(--sc-text-base);
  align-self: flex-start;
}

.confirm-warning {
  color: var(--v-surface_error_default-base) !important;
}

.confirm-btn {
  min-width: 110px;
  height: 36px;
  color: var(--v-common_text-base);
  font-weight: var(--sc-weight-semi);
  font-size: var(--sc-text-base);
  text-transform: none !important;
  letter-spacing: 0 !important;
  border-radius: var(--sc-radius-md) !important;
}

.confirm-btn--danger {
  background-color: var(--v-surface_error_default-base) !important;
}
</style>